import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Header = () => {
  return (
    <PrivacyPolicyContainer>
      <p>Last Changed: May 14, 2025</p>
      <p>
        Welcome to Yoda Safety Services. By using our platform, you agree to
        comply with these Terms & Conditions. If you do not agree, please
        refrain from using our services.
      </p>
      <p>
        These Terms & Conditions govern your use of our website and services.
        Please read them carefully before using our platform.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Header;
